import React from "react";
import { Form } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import ClubhouseGameSummary from "./ClubhouseGameSummary";
import LeagueManagementGameSummary from "./LeagueManagementGameSummary";
import PitchCounts from "./PitchCounts";
import ScoreEntry from "./ScoreEntry";
import SubmitButton from "./SubmitButton";
import UmpireInfo from "./UmpireInfo";

import { useGameSummaryContext } from "../contexts/GameSummary";
import useGameSummaryHandlers from "../hooks/useGameSummaryHandlers";

const GameSummaryForm = (): React.JSX.Element => {
    const { methods } = useGameSummaryContext();
    const { onSubmit } = useGameSummaryHandlers();
    const location = useLocation();
    const isOnLeagueManagementPage = /league-management/.test(
        location.pathname,
    );
    return (
        <Form
            onSubmit={methods.handleSubmit(onSubmit)}
            id="gameSummaryForm"
            data-testid="gameSummaryForm"
        >
            <UmpireInfo />
            <ScoreEntry />
            <PitchCounts />

            {isOnLeagueManagementPage ? (
                <LeagueManagementGameSummary />
            ) : (
                <ClubhouseGameSummary />
            )}

            <SubmitButton />
        </Form>
    );
};

export default GameSummaryForm;
